import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Survey {

  static endpoints = {
    cpxHash      : `${baseUrl}/surveys/cpx-research/get-hash`,
    pollfishInfo : `${baseUrl}/surveys/pollfish/user-info`,
    yunoInfo     : `${baseUrl}/surveys/yuno/user-info`,
  };

  static postbackType = {
    CLAIM   : 1,
    REVERSAL: 2
  };

  static generateCpxHash() {
    return axios.get(this.endpoints.cpxHash).then((response)=> response.data.hash);
  };

  static pollfishInfo() {
    return axios.get(this.endpoints.pollfishInfo).then((response)=> response.data);
  };

  static yunoInfo() {
    return axios.get(this.endpoints.yunoInfo).then((response)=> response.data);
  };

}
